import r from "../../../node_modules/classnames/index.js";
import { paramCase as t } from "../../../node_modules/param-case/dist.es2015/index.js";
function e(r, t) {
  (null == t || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function n(r) {
  return function (r) {
    if (Array.isArray(r)) return e(r);
  }(r) || function (r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }(r) || function (r, t) {
    if (r) {
      if ("string" == typeof r) return e(r, t);
      var n = Object.prototype.toString.call(r).slice(8, -1);
      if ("Object" === n && r.constructor && (n = r.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return e(r, t);
    }
  }(r) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function o(e) {
  var i,
    a = arguments[arguments.length - 1],
    f = [];
  return "object" == typeof a ? (i = Array.from(arguments).slice(1, arguments.length - 1), f = Object.keys(a).map(function (r) {
    if (a[r]) return r.startsWith(e) ? r : e + "--" + t(r);
  }).filter(function (r) {
    return r;
  })) : i = Array.from(arguments).slice(1), r.apply(void 0, [o.prefix + e].concat(n(f), n(i)));
}
o.prefix = "undefined" != typeof jest ? "" : "kaseya-ui-";
export { o as componentName };